import { createContext } from 'react'

const ColorModeContext = createContext({})

export default ColorModeContext
